<div class="content no-padding" id="trip">
    <form class="form-inline controls" novalidate>
		<ngx-slider [(value)]="minValue" [(highValue)]="maxValue" [options]="options" (userChangeEnd)="onUserChangeEnd($event)"></ngx-slider>
        <div>
            <div class="btn-group pull-right">
                <button class="btn btn-primary" (click)="goFastBack()" [disabled]="tripMarkers?.length == 0" title="First Point">
                    <i class="fa fa-fast-backward"></i>
                </button>
                <button class="btn btn-primary" (click)="goBack()" [disabled]="tripMarkers?.length == 0" title="Previous Point">
                    <i class="fa fa-backward"></i>
                </button>
                <button class="btn btn-primary" (click)="runPlayback(true)" *ngIf="!playback.playing" [disabled]="tripMarkers?.length == 0" title="Play">
                    <i class="fa fa-play"></i>
                </button>
                <button class="btn btn-primary" (click)="runPlayback(false)" *ngIf="playback.playing" [disabled]="tripMarkers?.length == 0" title="Pause">
                    <i class="fa fa-pause"></i>
                </button>
                <button class="btn btn-primary" (click)="goFwd()" [disabled]="tripMarkers?.length == 0" title="Next Point">
                    <i class="fa fa-forward"></i>
                </button>
                <button class="btn btn-primary" (click)="goFastFwd()" [disabled]="tripMarkers?.length == 0" title="Last Point">
                    <i class="fa fa-fast-forward"></i>
                </button>
                <button class="btn btn-primary" (click)="prevDate()" title="Previous Day">
                    <i class="fa fa-angle-left"></i>
                </button>
                <!-- <button class="btn btn-default date-btn" [innerHtml]="currentDate.format('D/MMM')"></button> -->
                <input type="date" id="datePicker" class="form-control inline-trip no-padding" style="background: white;" [ngModelOptions]="{standalone: true}" [(ngModel)]="currentDateStr" (change)="onDateChange()">
                <button [disabled]="!hasTomorrow" class="btn btn-primary" (click)="nextDate()" title="Next Day">
                    <i class="fa fa-angle-right"></i>
                </button>
            </div>
        </div>
        <div class="pt-2 px-2 trip-panel trip-panel-width" *ngIf="currentPoint?.status">
            <table class="whole-row">
                <tr>
                    <td style="width: 45%;">{{ currentPoint.datetime }}</td>
                    <td style="width: 25%">{{ currentPoint.status }}</td>
                    <td style="width: 30%">{{ currentPoint.speed }}</td>
                </tr>
            </table>
            <p class="mt-0" class="trip-location">{{ currentPoint.location }}</p>
        </div>
    </form>
	<div *ngIf="globalProvider == 'Google'">
		<app-gmap></app-gmap>
	</div>
	<div *ngIf="globalProvider == 'OpenStreetMap'">
		<app-openmap></app-openmap>
	</div>
</div>